/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import emailjs from 'emailjs-com';
import "./modal.css";
import './contact.css'

function Modal({ setOpenModal, projectId }) {

  const [projectID, setProjectID] = useState('')
  const [error, setError] = useState()
  const [sent, setSent] = useState(true)
  const [RespMessage, setRespMessage] = useState('')
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    company: '',
    message: '',
  })

  const form = useRef();

  const handleChange = (e) => {
    let value = e.target.value
    setFormData({ ...formData, [e.target.name]: value })
  }

  useEffect(() => {
    setProjectID(projectId)
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(false)
    const serviceId = process.env.REACT_APP_SERVICE_ID;
    const templateId = process.env.REACT_APP_TEMPL_ID;
    const userId = process.env.REACT_APP_EMAILJS_USER_ID;

    emailjs.sendForm(serviceId, templateId, form.current, userId)
      .then((result) => {
        setError(false)
        setRespMessage('Meddelandet har skickats')
      }, (error) => {
        setError(true)
        setRespMessage('Det gick inte att skicka meddelande')
      }).then(() => {
        setFormData({
          name: '',
          email: '',
          company: '',
          message: '',
          mobile: ''
        })
        setSent(true)
      });

  };
  return (
    <div className="modalBackground">
      <div className="modalContainer">
        <div className="titleCloseBtn">
          <button
            onClick={() => {
              setOpenModal(false);
            }}
          >
            X
          </button>
        </div>
        <form ref={form} onSubmit={handleSubmit} className='contact-form'>
          <h3>Kontakta oss</h3>
          <span style={{ backgroundColor: '#ccc', padding: '3px' }}>Projekt kod: {projectID}</span>
          <input onChange={handleChange} type="hidden" name="id" value={projectID} />
          <label>Namn</label>
          <input onChange={handleChange} type="text" name="name" value={formData.name} required />
          <label>Företag</label>
          <input onChange={handleChange} type="text" name="company" value={formData.company} required />
          <label>Mobil</label>
          <input onChange={handleChange} type="tel" name="mobile" value={formData.mobile} required />
          <label>E-Post</label>
          <input onChange={handleChange} type="email" name="email" value={formData.email} required />
          <label>Meddelande</label>
          <textarea rows="6" onChange={handleChange} value={formData.message} name="message" />
          <input className='contact-btn' type="submit" value={!sent ? '...Skickas' : 'Skicka'} />
          <span className={error ? 'error' : 'success'}>{RespMessage}</span>
        </form>
      </div>
    </div>
  );
}

export default Modal;